export { CollectibleSceneStories } from './CollectibleSceneStories'
